import { AEMScenes } from '@as-react/common-types';
import { checkModuleCollectionForComponent } from './redux/rootModules';
export const availableComponents = {
    [AEMScenes.BOOTSTRAP]: {
        clientOnly: true,
        componentName: AEMScenes.BOOTSTRAP,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BOOTSTRAP),
        promisedComponent: () => import('./components/bootstrap/Bootstrap'),
    },
    [AEMScenes.WISHLIST_MENU_ITEM]: {
        compressProps: true,
        componentName: AEMScenes.WISHLIST_MENU_ITEM,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.WISHLIST_MENU_ITEM),
        promisedComponent: () => import('./containers/WishlistMenuItemContainer'),
    },
    [AEMScenes.GUEST_REDIRECT]: {
        compressProps: true,
        componentName: AEMScenes.GUEST_REDIRECT,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.GUEST_REDIRECT),
        promisedComponent: () => import('./containers/GuestRedirectContainer'),
    },
    [AEMScenes.PRODUCT_DETAIL_V2]: {
        componentName: AEMScenes.PRODUCT_DETAIL_V2,
        displayContents: true,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_DETAIL_V2),
        promisedComponent: () => import('./containers/product/ProductDetailV2Container'),
    },
    [AEMScenes.COOKIE_MESSAGE]: {
        compressProps: true,
        componentName: AEMScenes.COOKIE_MESSAGE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.COOKIE_MESSAGE),
        promisedComponent: () => import('./components/common/cookie-message/CookieMessage'),
    },
    [AEMScenes.MONETATE]: {
        compressProps: true,
        componentName: AEMScenes.MONETATE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.MONETATE),
        promisedComponent: () => import('./containers/MonetateContainer'),
    },
    [AEMScenes.PRODUCT_GROUP]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_GROUP,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_GROUP),
        promisedComponent: () => import('./containers/product/ProductGroupContainer'),
    },
    [AEMScenes.PRODUCT_LISTER_DEPRECATED]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_LISTER_DEPRECATED,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_LISTER_DEPRECATED),
        promisedComponent: () => import('./containers/product/ProductListerContainer'),
    },
    [AEMScenes.PRODUCT_LISTER]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_LISTER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_LISTER),
        promisedComponent: () => import('./components/product-lister/ProductLister'),
    },
    [AEMScenes.ESSENTIALS]: {
        compressProps: true,
        componentName: AEMScenes.ESSENTIALS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ESSENTIALS),
        promisedComponent: () => import('./containers/EssentialsContainer'),
    },
    [AEMScenes.CAMPAIGN_GROUP]: {
        compressProps: true,
        clientOnly: true,
        componentName: AEMScenes.CAMPAIGN_GROUP,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CAMPAIGN_GROUP),
        promisedComponent: () => import('./components/campaign-group/CampaignGroup'),
    },
    [AEMScenes.SEARCH_MENU_ITEM]: {
        compressProps: true,
        componentName: AEMScenes.SEARCH_MENU_ITEM,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SEARCH_MENU_ITEM),
        promisedComponent: () => import('./containers/MenuSearchContainer'),
    },
    [AEMScenes.AUTHOR_DATA]: {
        compressProps: true,
        componentName: AEMScenes.AUTHOR_DATA,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.AUTHOR_DATA),
        promisedComponent: () => import('./containers/AuthorDataContainer'),
    },
    [AEMScenes.AUTHOR_INFORMATION]: {
        compressProps: true,
        componentName: AEMScenes.AUTHOR_INFORMATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.AUTHOR_INFORMATION),
        displayContents: true,
        promisedComponent: () => import('./containers/AuthorInformationContainer'),
    },
    [AEMScenes.AUTHOR_LINKED_CONTENT_PAGES]: {
        compressProps: true,
        componentName: AEMScenes.AUTHOR_LINKED_CONTENT_PAGES,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.AUTHOR_LINKED_CONTENT_PAGES),
        promisedComponent: () => import('./containers/AuthorLinkedContentPagesContainer'),
    },
    [AEMScenes.AUTHOR_LINKED_PRODUCTS]: {
        compressProps: true,
        componentName: AEMScenes.AUTHOR_LINKED_PRODUCTS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.AUTHOR_LINKED_PRODUCTS),
        promisedComponent: () => import('./containers/AuthorLinkedProductsContainer'),
    },
    [AEMScenes.BASKET_MENU_ITEM]: {
        compressProps: true,
        componentName: AEMScenes.BASKET_MENU_ITEM,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BASKET_MENU_ITEM),
        promisedComponent: () => import('./components/basket/basket-menu-item/BasketMenuItem'),
    },
    [AEMScenes.BREADCRUMB]: {
        compressProps: true,
        serverOnly: true,
        componentName: AEMScenes.BREADCRUMB,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BREADCRUMB),
        promisedComponent: () => import('./components/breadcrumb/Breadcrumb'),
    },
    [AEMScenes.CONTENT_TILE_LISTER]: {
        componentName: AEMScenes.CONTENT_TILE_LISTER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CONTENT_TILE_LISTER),
        promisedComponent: () => import('./containers/ContentTileListerContainer'),
    },
    [AEMScenes.PRODUCT_RELEVANT_CONTENT]: {
        componentName: AEMScenes.PRODUCT_RELEVANT_CONTENT,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_RELEVANT_CONTENT),
        promisedComponent: () => import('./components/product-detail/product-relevant-content/ProductRelevantContent'),
    },
    [AEMScenes.GIFT_VOUCHER]: {
        compressProps: true,
        componentName: AEMScenes.GIFT_VOUCHER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.GIFT_VOUCHER),
        promisedComponent: () => import('./containers/GiftVoucherContainer'),
    },
    [AEMScenes.SINGLE_PRODUCT_TILE]: {
        compressProps: true,
        componentName: AEMScenes.SINGLE_PRODUCT_TILE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SINGLE_PRODUCT_TILE),
        promisedComponent: () => import('./containers/SingleProductTileContainer'),
    },
    [AEMScenes.LIST]: {
        compressProps: true,
        componentName: AEMScenes.LIST,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.LIST),
        promisedComponent: () => import('./components/list/List'),
    },
    [AEMScenes.ACCOUNT_ACTIVATION]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_ACTIVATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_ACTIVATION),
        promisedComponent: () => import('./containers/account/AccountActivationContainer'),
    },
    [AEMScenes.ACCOUNT_CREDIT_CARD]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_CREDIT_CARD,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_CREDIT_CARD),
        promisedComponent: () => import('./containers/account/AccountCreditCardContainer'),
    },
    [AEMScenes.ACCOUNT_MENU_ITEM]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_MENU_ITEM,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_MENU_ITEM),
        promisedComponent: () => import('./containers/account/AccountMenuItemContainer'),
    },
    [AEMScenes.ACCOUNT_PREFERENCES]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_PREFERENCES,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_PREFERENCES),
        promisedComponent: () => import('./containers/account/AccountPreferencesContainer'),
    },
    [AEMScenes.ACCOUNT_UNSUBSCRIBE]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_UNSUBSCRIBE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_UNSUBSCRIBE),
        promisedComponent: () => import('./containers/account/AccountUnsubscribeContainer'),
    },
    [AEMScenes.ACCOUNT_VOUCHERS]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_VOUCHERS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_VOUCHERS),
        promisedComponent: () => import('./containers/account/AccountVouchersContainer'),
    },
    [AEMScenes.ORDER_OVERVIEW]: {
        compressProps: true,
        componentName: AEMScenes.ORDER_OVERVIEW,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ORDER_OVERVIEW),
        promisedComponent: () => import('./containers/OrderOverviewContainer'),
    },
    [AEMScenes.LANGUAGE_MENU_ITEM]: {
        compressProps: true,
        componentName: AEMScenes.LANGUAGE_MENU_ITEM,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.LANGUAGE_MENU_ITEM),
        promisedComponent: () => import('./containers/LanguageMenuItemContainer'),
    },
    [AEMScenes.RELATED_CATEGORIES]: {
        compressProps: true,
        componentName: AEMScenes.RELATED_CATEGORIES,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.RELATED_CATEGORIES),
        promisedComponent: () => import('./containers/RelatedCategoriesContainer'),
    },
    [AEMScenes.WISHLIST]: {
        compressProps: true,
        componentName: AEMScenes.WISHLIST,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.WISHLIST),
        promisedComponent: () => import('./containers/WishlistContainer'),
    },
    [AEMScenes.PRODUCT_WIZARD]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_WIZARD,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_WIZARD),
        promisedComponent: () => import('./containers/product/ProductWizardContainer'),
    },
    [AEMScenes.PRODUCT_GROUP_FREDHOPPER]: {
        componentName: AEMScenes.PRODUCT_GROUP_FREDHOPPER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_GROUP_FREDHOPPER),
        promisedComponent: () => import('./containers/product/ProductGroupFredhopperContainer'),
    },
    [AEMScenes.PRODUCT_GROUP_MONETATE]: {
        componentName: AEMScenes.PRODUCT_GROUP_MONETATE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_GROUP_MONETATE),
        promisedComponent: () => import('./containers/product/ProductGroupMonetateContainer'),
    },
    [AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_FREDHOPPER]: {
        componentName: AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_FREDHOPPER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_FREDHOPPER),
        promisedComponent: () => import('./containers/product/ProductGroupPdpComparisonFredhopperContainer'),
    },
    [AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_MONETATE]: {
        componentName: AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_MONETATE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_MONETATE),
        promisedComponent: () => import('./containers/product/ProductGroupPdpComparisonMonetateContainer'),
    },
    [AEMScenes.PRODUCT_RECENTLY_VIEWED]: {
        componentName: AEMScenes.PRODUCT_RECENTLY_VIEWED,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_RECENTLY_VIEWED),
        promisedComponent: () => import('./containers/product/ProductRecentlyViewedContainer'),
    },
    [AEMScenes.PRODUCT_REVIEW]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_REVIEW,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_REVIEW),
        promisedComponent: () => import('./containers/product/ProductReviewContainer'),
    },
    [AEMScenes.PRODUCT_COMPARISON]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_COMPARISON,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_COMPARISON),
        promisedComponent: () => import('./containers/product/ProductComparisonContainer'),
    },
    [AEMScenes.BASKET_OVERVIEW_V2]: {
        compressProps: true,
        componentName: AEMScenes.BASKET_OVERVIEW_V2,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BASKET_OVERVIEW_V2),
        promisedComponent: () => import('./containers/checkout/BasketOverviewContainer'),
    },
    [AEMScenes.BOXED_TITLE]: {
        compressProps: true,
        serverOnly: true,
        componentName: AEMScenes.BOXED_TITLE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BOXED_TITLE),
        promisedComponent: () => import('./components/boxed-title/BoxedTitle'),
    },
    [AEMScenes.COLLAPSIBLE_LIST]: {
        compressProps: true,
        componentName: AEMScenes.COLLAPSIBLE_LIST,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.COLLAPSIBLE_LIST),
        promisedComponent: () => import('./components/collapsible-list/CollapsibleList'),
    },
    [AEMScenes.CHECKOUT]: {
        compressProps: true,
        componentName: AEMScenes.CHECKOUT,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CHECKOUT),
        promisedComponent: () => import('./containers/checkout/CheckoutContainer'),
    },
    [AEMScenes.CHECKOUT_HEADER]: {
        compressProps: true,
        componentName: AEMScenes.CHECKOUT_HEADER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CHECKOUT_HEADER),
        promisedComponent: () => import('./containers/checkout/CheckoutHeaderContainer'),
    },
    [AEMScenes.CONTENT_DETAIL_HEADER]: {
        compressProps: true,
        componentName: AEMScenes.CONTENT_DETAIL_HEADER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CONTENT_DETAIL_HEADER),
        displayContents: true,
        promisedComponent: () => import('./components/content/ContentDetailHeader'),
    },
    [AEMScenes.VIDEO]: {
        compressProps: true,
        componentName: AEMScenes.VIDEO,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.VIDEO),
        promisedComponent: () => import('./components/video-player/VideoPlayer'),
    },
    [AEMScenes.BUY_PAYMENT_REQUEST]: {
        compressProps: true,
        componentName: AEMScenes.BUY_PAYMENT_REQUEST,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BUY_PAYMENT_REQUEST),
        displayContents: true,
        promisedComponent: () => import('./containers/checkout/CheckoutPaymentRequestContainer'),
    },
    [AEMScenes.CHECKOUT_CONFIRMATION]: {
        compressProps: true,
        componentName: AEMScenes.CHECKOUT_CONFIRMATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CHECKOUT_CONFIRMATION),
        promisedComponent: () => import('./containers/checkout/CheckoutConfirmationContainer'),
    },
    [AEMScenes.CHECKOUT_PAYMENT_REQUEST_CONFIRMATION]: {
        compressProps: true,
        componentName: AEMScenes.CHECKOUT_PAYMENT_REQUEST_CONFIRMATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CHECKOUT_PAYMENT_REQUEST_CONFIRMATION),
        promisedComponent: () => import('./containers/checkout/CheckoutPaymentRequestConfirmationContainer'),
    },
    [AEMScenes.RENTAL]: {
        componentName: AEMScenes.RENTAL,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.RENTAL),
        promisedComponent: () => import('./containers/RentalContainer'),
    },
    [AEMScenes.COUNTDOWN]: {
        componentName: AEMScenes.COUNTDOWN,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.COUNTDOWN),
        promisedComponent: () => import('./components/common/countdown/Countdown'),
    },
    [AEMScenes.BRAND_TILE_LISTER]: {
        compressProps: true,
        componentName: AEMScenes.BRAND_TILE_LISTER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BRAND_TILE_LISTER),
        promisedComponent: () => import('./containers/BrandListerContainer'),
    },
    [AEMScenes.FOLDER_NAVIGATION]: {
        compressProps: true,
        componentName: AEMScenes.FOLDER_NAVIGATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.FOLDER_NAVIGATION),
        promisedComponent: () => import('./components/folder/folder-navigation/FolderNavigation'),
    },
    [AEMScenes.PRODUCT_INSPIRATION]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_INSPIRATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_INSPIRATION),
        promisedComponent: () => import('./components/product-inspiration/ProductInspiration'),
    },
    [AEMScenes.RETURN_ITEMS]: {
        compressProps: true,
        componentName: AEMScenes.RETURN_ITEMS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.RETURN_ITEMS),
        promisedComponent: () => import('./containers/ReturnItemsContainer'),
    },
    [AEMScenes.NEWSLETTER_SUBSCRIBE]: {
        compressProps: true,
        componentName: AEMScenes.NEWSLETTER_SUBSCRIBE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.NEWSLETTER_SUBSCRIBE),
        promisedComponent: () => import('./containers/NewsletterSubscribeContainer'),
    },
    [AEMScenes.ACCOUNT_PASSWORD_RESET]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_PASSWORD_RESET,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_PASSWORD_RESET),
        promisedComponent: () => import('./containers/account/AccountPasswordResetContainer'),
    },
    [AEMScenes.CHANGE_PASSWORD]: {
        compressProps: true,
        componentName: AEMScenes.CHANGE_PASSWORD,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CHANGE_PASSWORD),
        promisedComponent: () => import('./containers/ChangePasswordContainer'),
    },
    [AEMScenes.ACCOUNT_OVERVIEW_INFO]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_OVERVIEW_INFO,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_OVERVIEW_INFO),
        promisedComponent: () => import('./containers/account/AccountOverviewInfoContainer'),
    },
    [AEMScenes.ACCOUNT_MENU]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_MENU,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_MENU),
        promisedComponent: () => import('./containers/account/AccountMenuProfileContainer'),
    },
    [AEMScenes.SHOP_THE_LOOK]: {
        compressProps: true,
        componentName: AEMScenes.SHOP_THE_LOOK,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SHOP_THE_LOOK),
        promisedComponent: () => import('./containers/ShopTheLookContainer'),
    },
    [AEMScenes.ACCOUNT_DELIVERY_ADDRESSES]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_DELIVERY_ADDRESSES,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_DELIVERY_ADDRESSES),
        promisedComponent: () => import('./containers/account/AccountDeliveryAddressesContainer'),
    },
    [AEMScenes.ACCOUNT_ORDER_HISTORY]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_ORDER_HISTORY,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_ORDER_HISTORY),
        promisedComponent: () => import('./containers/account/AccountOrderHistoryContainer'),
    },
    [AEMScenes.ACCOUNT_PROFILE_DETAILS]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_PROFILE_DETAILS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_PROFILE_DETAILS),
        promisedComponent: () => import('./containers/account/AccountProfileDetailsContainer'),
    },
    [AEMScenes.PRODUCT_CONTENT_VIDEO]: {
        compressProps: true,
        componentName: AEMScenes.PRODUCT_CONTENT_VIDEO,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_CONTENT_VIDEO),
        promisedComponent: () => import('./containers/product/ProductContentVideoContainer'),
    },
    [AEMScenes.LOGIN]: {
        compressProps: true,
        componentName: AEMScenes.LOGIN,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.LOGIN),
        promisedComponent: () => import('./containers/LoginContainer'),
    },
    [AEMScenes.SLIDER]: {
        componentName: AEMScenes.SLIDER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SLIDER),
        promisedComponent: () => import('./containers/SliderContainer'),
    },
    [AEMScenes.CAROUSEL]: {
        compressProps: true,
        componentName: AEMScenes.CAROUSEL,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CAROUSEL),
        promisedComponent: () => import('./components/carousel/Carousel'),
    },
    [AEMScenes.CATEGORY_TILE]: {
        compressProps: true,
        componentName: AEMScenes.CATEGORY_TILE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.CATEGORY_TILE),
        promisedComponent: () => import('./containers/CategoryTileContainer'),
    },
    [AEMScenes.TEASER]: {
        compressProps: true,
        componentName: AEMScenes.TEASER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.TEASER),
        promisedComponent: () => import('./containers/TeaserContainer'),
    },
    [AEMScenes.TEXT_BLOCK]: {
        compressProps: true,
        componentName: AEMScenes.TEXT_BLOCK,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.TEXT_BLOCK),
        promisedComponent: () => import('./components/text-block/TextBlock'),
    },
    [AEMScenes.FEEFO_BRAND_BADGE]: {
        compressProps: true,
        componentName: AEMScenes.FEEFO_BRAND_BADGE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.FEEFO_BRAND_BADGE),
        promisedComponent: () => import('./components/feefo-brand-badge/FeefoBrandBadge'),
    },
    [AEMScenes.REEVOO_CUSTOMER_EXPERIENCE]: {
        compressProps: true,
        componentName: AEMScenes.REEVOO_CUSTOMER_EXPERIENCE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.REEVOO_CUSTOMER_EXPERIENCE),
        promisedComponent: () => import('./components/reevoo-customer-experience/ReevooCustomerExperience'),
    },
    [AEMScenes.SOCIAL_LINKS]: {
        compressProps: true,
        componentName: AEMScenes.SOCIAL_LINKS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SOCIAL_LINKS),
        promisedComponent: () => import('./components/social-links/SocialLinks'),
    },
    [AEMScenes.LINE]: {
        compressProps: true,
        componentName: AEMScenes.LINE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.LINE),
        promisedComponent: () => import('./components/line/Line'),
    },
    [AEMScenes.STORE_GENERAL]: {
        componentName: AEMScenes.STORE_GENERAL,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.STORE_GENERAL),
        promisedComponent: () => import('./components/stores/StoreGeneral'),
    },
    [AEMScenes.STORE_DEPARTMENTS]: {
        componentName: AEMScenes.STORE_DEPARTMENTS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.STORE_DEPARTMENTS),
        promisedComponent: () => import('./components/stores/StoreDepartments'),
    },
    [AEMScenes.STORE_NEARBY_STORES]: {
        componentName: AEMScenes.STORE_NEARBY_STORES,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.STORE_NEARBY_STORES),
        promisedComponent: () => import('./components/stores/StoreNearbyStores'),
    },
    [AEMScenes.RECENTLY_OPENED_STORES]: {
        componentName: AEMScenes.RECENTLY_OPENED_STORES,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.RECENTLY_OPENED_STORES),
        promisedComponent: () => import('./components/stores/RecentlyOpenedStores'),
    },
    [AEMScenes.SERVICE_ORDER_TRACKING]: {
        compressProps: true,
        componentName: AEMScenes.SERVICE_ORDER_TRACKING,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SERVICE_ORDER_TRACKING),
        promisedComponent: () => import('./containers/ServiceOrderTrackingContainer'),
    },
    [AEMScenes.STORE_LOCATOR]: {
        componentName: AEMScenes.STORE_LOCATOR,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.STORE_LOCATOR),
        promisedComponent: () => import('./components/stores/store-locator/StoreLocator'),
    },
    [AEMScenes.PRODUCT_TOP_FIVE]: {
        compressProps: true,
        serverOnly: true,
        componentName: AEMScenes.PRODUCT_TOP_FIVE,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.PRODUCT_TOP_FIVE),
        promisedComponent: () => import('./components/product-top-five/ProductTopFive'),
    },
    [AEMScenes.SHOP_NUMBER]: {
        compressProps: true,
        componentName: AEMScenes.SHOP_NUMBER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SHOP_NUMBER),
        promisedComponent: () => import('./containers/ShopNumberContainer'),
    },
    [AEMScenes.GLOSSARY]: {
        compressProps: true,
        componentName: AEMScenes.GLOSSARY,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.GLOSSARY),
        promisedComponent: () => import('./containers/GlossaryContainer'),
    },
    [AEMScenes.ETICKET]: {
        compressProps: true,
        componentName: AEMScenes.ETICKET,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ETICKET),
        promisedComponent: () => import('./containers/EticketContainer'),
    },
    [AEMScenes.DISTINCTIVE_PRODUCT_DETAILS]: {
        compressProps: true,
        componentName: AEMScenes.DISTINCTIVE_PRODUCT_DETAILS,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.DISTINCTIVE_PRODUCT_DETAILS),
        promisedComponent: () => import('./components/distinctive-product-details/DistinctiveProductDetails'),
    },
    [AEMScenes.SHOPPING_BUDGET]: {
        compressProps: true,
        componentName: AEMScenes.SHOPPING_BUDGET,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.SHOPPING_BUDGET),
        promisedComponent: () => import('./containers/ShoppingBudgetContainer'),
    },
    [AEMScenes.VOUCHER]: {
        compressProps: true,
        componentName: AEMScenes.VOUCHER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.VOUCHER),
        promisedComponent: () => import('./containers/VoucherContainer'),
    },
    [AEMScenes.VOUCHER_ACTIVATION]: {
        compressProps: true,
        componentName: AEMScenes.VOUCHER_ACTIVATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.VOUCHER_ACTIVATION),
        promisedComponent: () => import('./components/voucher-activation/VoucherActivation'),
    },
    [AEMScenes.DELIVERY_CONDITIONS_BANNER]: {
        compressProps: true,
        componentName: AEMScenes.DELIVERY_CONDITIONS_BANNER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.DELIVERY_CONDITIONS_BANNER),
        promisedComponent: () => import('./containers/DeliveryConditionsBannerContainer'),
    },
    [AEMScenes.MOBILE_NAVIGATION]: {
        compressProps: true,
        displayContents: true,
        componentName: AEMScenes.MOBILE_NAVIGATION,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.MOBILE_NAVIGATION),
        promisedComponent: () => import('./containers/MobileNavigationContainer'),
    },
    [AEMScenes.ZITCHA_BANNER]: {
        componentName: AEMScenes.ZITCHA_BANNER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ZITCHA_BANNER),
        promisedComponent: () => import('./containers/zitcha/BannerContainer'),
    },
    [AEMScenes.ACCOUNT_ENRICHMENT]: {
        compressProps: true,
        componentName: AEMScenes.ACCOUNT_ENRICHMENT,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ACCOUNT_ENRICHMENT),
        promisedComponent: () => import('./containers/account/AccountEnrichmentContainer'),
    },
    [AEMScenes.BUTTON]: {
        compressProps: true,
        componentName: AEMScenes.BUTTON,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.BUTTON),
        promisedComponent: () => import('./components/button/Button'),
    },
    // Must be loaded at the end until issue with nested scripts for hydration is resolved
    [AEMScenes.ABTESTING]: {
        componentName: AEMScenes.ABTESTING,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.ABTESTING),
        promisedComponent: () => import('./containers/ab/ABTestingContainer'),
    },
    [AEMScenes.HEADER]: {
        compressProps: true,
        componentName: AEMScenes.HEADER,
        hasReduxModule: checkModuleCollectionForComponent(AEMScenes.HEADER),
        promisedComponent: () => import('./containers/HeaderContainer'),
    },
    [AEMScenes.HEADING]: {
        compressProps: true,
        serverOnly: true,
        componentName: AEMScenes.HEADING,
        hasReduxModule: false,
        promisedComponent: () => import('./components/heading/Heading'),
    },
    [AEMScenes.QUOTE]: {
        compressProps: true,
        serverOnly: true,
        componentName: AEMScenes.QUOTE,
        hasReduxModule: false,
        promisedComponent: () => import('./components/quote/Quote'),
    },
    [AEMScenes.IMAGE]: {
        compressProps: true,
        componentName: AEMScenes.IMAGE,
        hasReduxModule: false,
        displayContents: true,
        promisedComponent: () => import('./components/image/Image'),
    },
};
export const renderingTools = {
    redux: {
        configureStore: () => import('./redux/storeConfigure/storeConfigure'),
    },
    i18n: {
        instanceCreator: () => import('./config/i18n/instanceCreator.i18n'),
        instanceCreatorBackEnd: () => import('./config/i18n/instanceCreatorBackend.i18n'),
        frontEndInitOptions: () => import('./config/i18n/i18nConfigFrontEnd'),
        backendEndInitOptions: () => import('./config/i18n/i18nConfigBackend'),
    },
    numeral: () => import('./vendors/asNumeral'),
    cotopaxi: {
        version: () => import('./vendors/cotopaxi/usedVersionCotopaxi'),
    },
    andes: {
        version: () => import('./vendors/andes/usedVersionAndes'),
        preloadAssetFileGenerator: () => import('./vendors/andes/preloadAssetFileGenerator'),
    },
};
const reactVersion = process.env.REACT_VERSION ? process.env.REACT_VERSION : 'ECDEV-FE.0';
const buildTimestamp = process.env.BUILD_TIMESTAMP ? process.env.BUILD_TIMESTAMP : '0';
export const usedVersionReact = `${reactVersion}-${buildTimestamp}`;
